"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Note = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const company_entity_1 = require("./company.entity");
const note_document_map_entity_1 = require("./note-document-map.entity");
const opportunity_activity_map_entity_1 = require("./opportunity-activity-map.entity");
const opportunity_entity_1 = require("./opportunity.entity");
let Note = class Note {
};
exports.Note = Note;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Note.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Note.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Note.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Note.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "title", type: "varchar", length: 100, nullable: false }),
    tslib_1.__metadata("design:type", String)
], Note.prototype, "title", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "description", type: "text", nullable: false }),
    tslib_1.__metadata("design:type", String)
], Note.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], Note.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        onUpdate: "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], Note.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({
        name: "deleted_at",
        type: "timestamptz",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Note.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Note.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Note.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => company_entity_1.Company),
    (0, typeorm_1.JoinColumn)({ name: "company_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _d : Object)
], Note.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _e : Object)
], Note.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_activity_map_entity_1.OpportunityActivityMap),
    (0, typeorm_1.JoinColumn)({ name: "activity_id" }),
    tslib_1.__metadata("design:type", typeof (_f = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _f : Object)
], Note.prototype, "activity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => note_document_map_entity_1.NoteDocumentMap, (noteDoc) => noteDoc.note),
    tslib_1.__metadata("design:type", Array)
], Note.prototype, "noteDocs", void 0);
exports.Note = Note = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "note" })
], Note);
